export default function () {
    let i=0,res={},l = arguments.length
    for(;i<l;i++){
        for(var key in arguments[i]){
            if(arguments[i].hasOwnProperty(key)){
                res[key]=arguments[i][key]
            }
        }
    }
    return res
}



// WEBPACK FOOTER //
// ./src/utils/merge.js